import { useState } from "react";
import { AvailableForm, Script, ScriptForm } from "@/features/dashboard/types";
import { ScriptScoreTable } from "@/features/dashboard/components";
import { MobileScriptView } from "./MobileScriptView";
import { VersionControlPanel } from "@/features/versions/components";
import { VersionSelectionProvider } from "@/features/versions/context/VersionSelectionContext";
import { useIsMobile } from "@/hooks/use-mobile";

interface DashboardListProps {
  scripts: Script[];
  formatDate: (dateString: string) => string;
  onShare: (script: Script, scriptForm: ScriptForm) => void;
  onAnalyze: (scriptForm: ScriptForm, scriptName: string, script: Script) => void;
  onAddForm: (script: Script, formId: string) => Promise<void>;
  availableFormsByScript: Record<string, AvailableForm[]>;
  addingForm: { scriptId: string; formId: string } | null;
  onRefresh?: () => Promise<void>;
}

export const DashboardList = ({
  scripts,
  formatDate,
  onShare,
  onAnalyze,
  onAddForm,
  availableFormsByScript,
  addingForm,
  onRefresh,
}: DashboardListProps) => {
  const isMobile = useIsMobile();
  const [versionControlOpen, setVersionControlOpen] = useState<string | null>(null);

  if (isMobile) {
    return (
      <VersionSelectionProvider>
        <MobileScriptView
          scripts={scripts}
          formatDate={formatDate}
          onShare={onShare}
          onAnalyze={onAnalyze}
          onAddForm={onAddForm}
          availableFormsByScript={availableFormsByScript}
          addingForm={addingForm}
          onOpenVersionControl={setVersionControlOpen}
          onRefresh={onRefresh}
        />
        {versionControlOpen && (
          <VersionControlPanel
            script={scripts.find((s) => s.id === versionControlOpen)!}
            open={!!versionControlOpen}
            onClose={() => setVersionControlOpen(null)}
            formatDate={formatDate}
            onRefresh={onRefresh}
          />
        )}
      </VersionSelectionProvider>
    );
  }

  return (
    <VersionSelectionProvider>
      <ScriptScoreTable
        scripts={scripts}
        formatDate={formatDate}
        onShare={onShare}
        onAnalyze={onAnalyze}
        onAddForm={onAddForm}
        availableFormsByScript={availableFormsByScript}
        addingForm={addingForm}
        onRefresh={onRefresh}
      />
    </VersionSelectionProvider>
  );
};
